var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":"Email Address","outlined":"","dense":"","placeholder":"Enter email address","rules":_vm.required ? _vm.emailRules : []},on:{"input":function($event){return _vm.$emit('input', _vm.email)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})
}
var staticRenderFns = []

export { render, staticRenderFns }